import axios from 'axios';

const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;
const API_URL = `${BACKEND_URL}/api/setting/website/`;
const ORDER_API_URL = `${BACKEND_URL}/api/order/`;

const getWebsiteFromUrl = async (url) => {
    return await axios.post(API_URL + 'searchurl', {url});
};

const getItemDataFromUrl = async (url) => {
    return await axios.post(ORDER_API_URL + 'itemdata', {url});
};

const getWebsiteFeesByUrl = async (url, customerId) => {
    return await axios.post(API_URL + 'fees', { url, ...(customerId ? { customerId } : {}) });
};

export default {
  getWebsiteFromUrl,
  getItemDataFromUrl,
  getWebsiteFeesByUrl,
};
